// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"0ae8884f","256":"fd5c929e","494":"d4419e0e","621":"819233ef","735":"7d70c5ba","787":"ce6c8d4b"}[chunkId] + ".chunk.js";
};